<template>
  <SupportComponent />
</template>

<script lang="ts">
import SupportComponent from "@/components/support/Support.vue";
import { defineComponent } from "vue";

const componentName = "SupportRoute";

export default defineComponent({
  name: componentName,
  components: { SupportComponent },
});
</script>
